<script setup>
import { computed } from "vue";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  icon: { type: [Object, Function], default: null },
  iconSize: { type: Number, default: 48 },
  title: { type: String, default: "" },
  description: { type: String, default: "" },
  class: { type: String, default: "" },
});

const rootClass = computed(() => cn("empty-state", props.class));
</script>

<template>
  <div :class="rootClass">
    <div v-if="icon || $slots.icon" class="icon-wrap">
      <slot name="icon">
        <component :is="icon" :size="iconSize" class="text-gray-300" />
      </slot>
    </div>
    <div v-if="title || $slots.title" class="title">
      <slot name="title">{{ title }}</slot>
    </div>
    <div v-if="description || $slots.description" class="description">
      <slot name="description">{{ description }}</slot>
    </div>
    <div v-if="$slots.action" class="action-wrap">
      <slot name="action" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.empty-state {
  @apply w-full h-full flex flex-col items-center justify-center text-center px-6 py-12;

  .icon-wrap {
    @apply mb-6;
  }

  .title {
    @apply text-gray-800 font-semibold mb-1;
    font-size: 17px;
  }

  .description {
    @apply text-muted-foreground;
    font-size: 15px;
  }

  .action-wrap {
    @apply mt-4;
  }
}
</style>
